module.exports = __webpack_public_path__ + "img/52.f2977727.png";